import { createRoute } from '@tanstack/react-router'
import { t } from 'i18next'

import { StaticRouteParameter } from 'config/routing'
import { Overview } from 'domains/MediaPlatforms/Setup'
import { mediaPlatformRoute } from 'pages/NWPlatform/MediaPlatforms/MediaPlatform'
import { Structure } from 'pages/NWPlatform/MediaPlatforms/MediaPlatform/Setup'

export const mediaPlatformSetupRoute = createRoute({
  getParentRoute: () => mediaPlatformRoute,
  path: StaticRouteParameter.SETUP,
  loader: () => ({
    crumb: t('entity:publishing.setup', { count: 1 }),
  }),
})

export const mediaPlatformSetupLayoutRoute = createRoute({
  getParentRoute: () => mediaPlatformSetupRoute,
  id: 'mediaPlatformSetupLayout',
  component: Structure,
})

export const mediaPlatformSetupOverviewRoute = createRoute({
  getParentRoute: () => mediaPlatformSetupLayoutRoute,
  path: '/',
  component: Overview,
})
